import LeftArrow from "../../../../assets/icons/left-arrow.png"
import { history } from "../../../../shared/_helpers/history";

export const MainHeader = () => {
    return (
        <div className="product-info-header">
            <div className="left-nav" onClick={() => history.replace("/app/my-products")}> <img src={LeftArrow} alt="" /> </div>
            <div className="other-item-wrap">
                <div className="heading-text">New Product</div>
                <div className="heading-msg">Kindly add a new product to your store by filling out the necessary information below</div>
            </div>
        </div>
    )
}